export default [
  { method: "get", path: "/Classes/GetCourseSuggestions" },
  { method: "get", path: "/tags" },
  { method: "get", path: "/awards?" },
  { method: "get", path: "/WorkloadsReports/" }
];
